import axios from "axios";
import store from '@/state/store'

export const state = {
    token: null,
    tokenParsed: {},
    refreshToken: null,
    tokenExpiresIn: null,
    refreshTokenExpiresIn: null,
}

export const mutations = {
    SET_TOKEN(state, payload) {
        state.token = payload
    },
    SET_TOKEN_PARSED(state, payload) {
        state.tokenParsed = payload
    },
    SET_REFRESH_TOKEN(state, payload) {
        state.refreshToken = payload
        localStorage.setItem('refreshToken', state.refreshToken)
    },
    SET_TOKEN_EXPIRES_IN(state, payload) {
        state.tokenExpiresIn = payload
        localStorage.setItem('tokenExpiresIn', state.tokenExpiresIn)
    },
    SET_REFRESH_TOKEN_EXPIRES_IN(state, payload) {
        state.refreshTokenExpiresIn = payload
        localStorage.setItem('refreshTokenExpiresIn', state.refreshTokenExpiresIn)
    },
}

export const getters = {
    authenticated(state) {
        return state.token && state.tokenParsed ? true : false;
    },
    isAdmin(state) {
        return state.tokenParsed.authorities?.includes("ADMIN");
    },
    isGerente(state) {
        return state.tokenParsed.authorities?.includes("GERENTE");
    },
    isAtendente(state) {
        return state.tokenParsed.authorities?.some(a => a == "COLABORADOR" || a == "SUPERVISOR");
    },
    isSupervisor(state) {
        return state.tokenParsed.authorities?.includes("SUPERVISOR");
    },
    isTotem(state) {
        return state.tokenParsed.authorities?.includes("TOTEM");
    },
    isTelevisao(state) {
        return state.tokenParsed.authorities?.includes("TELEVISAO");
    },
    empresaDefault(state) {
        return state.tokenParsed.EMPRESA;
    },
    totemDefault(state) {
        return state.tokenParsed.TOTEM;
    },
    token(state) {
        return state.token;
    },
    refreshToken(state) {
        return state.refreshToken;
    },
    tokenParsed(state) {
        return state.tokenParsed;
    },
    username(state) {
        return state.tokenParsed.preferred_username;
    },
    authorities(state) {
        return state.tokenParsed.authorities ? state.tokenParsed.authorities : []
    },
    databases(state) {
        return state.tokenParsed.databases;
    },
}

export const actions = {

    async signIn({ dispatch, commit }, payload) {
        var url = process.env.VUE_APP_AUTH_LOGIN;
        await axios({
            method: "post",
            url: url,
            data: payload,
            headers: { "content-type": "application/x-www-form-urlencoded" },

        }).then((response) => {
            commit('SET_TOKEN_EXPIRES_IN', response.data.expires_in)
            commit('SET_REFRESH_TOKEN_EXPIRES_IN', response.data.refresh_expires_in)
            commit('SET_REFRESH_TOKEN', response.data.refresh_token)
            return dispatch('getUserInfo', response.data.access_token)
        })
    },

    async getUserInfo({ commit, state }, token) {
        if (token) {
            commit('SET_TOKEN', token)
        }
        if (!state.token) {
            return
        }

        var url = process.env.VUE_APP_AUTH_USER;

        try {
            await axios({
                method: "get",
                url: url,
            }).then((response) => {
                store.dispatch('sessao/changeEmpresa', {})
                store.dispatch('sessao/changeTotem', {})
                return commit('SET_TOKEN_PARSED', response.data)
            })
        } catch (error) {
            commit('SET_TOKEN', null)
            commit('SET_REFRESH_TOKEN', null)
            commit('SET_TOKEN_PARSED', {})
            commit('SET_TOKEN_EXPIRES_IN', null)
            commit('SET_REFRESH_TOKEN_EXPIRES_IN', null)
        }
    },

    async getRefreshToken({ dispatch, commit, state }) {       
        var url = process.env.VUE_APP_AUTH_LOGIN;
        var bodyFormData = new URLSearchParams();

        bodyFormData.append("grant_type", "refresh_token");
        bodyFormData.append(
            "client_id",
            process.env.VUE_APP_AUTH_CLIENT_ID
        );
        bodyFormData.append("refresh_token", state.refreshToken);

        try {
            await axios({
                method: "post",
                url: url,
                data: bodyFormData,
                headers: { "content-type": "application/x-www-form-urlencoded" },

            }).then((response) => {
                commit('SET_TOKEN', response.data.access_token)
                commit('SET_REFRESH_TOKEN', response.data.refresh_token)
                /* eslint-disable no-console */
               // console.log('refresh', response.data)
                /* eslint-enable no-console */
            })
        } catch (error) {
            dispatch('signOut').then(() => {
                location.href = '/login'
            })
        }

    },

    async signOut({ commit }) {
        var url = process.env.VUE_APP_AUTH_LOGOUT

        var bodyFormData = new URLSearchParams();
        bodyFormData.append("client_id", process.env.VUE_APP_AUTH_CLIENT_ID);
        bodyFormData.append("refresh_token", localStorage.getItem('refreshToken'));

        return await axios({
            method: "post",
            url: url,
            data: bodyFormData,
            headers: { "content-type": "application/x-www-form-urlencoded" },
        }).then(() => {
            commit('SET_TOKEN_PARSED', {})
            commit('SET_REFRESH_TOKEN', null)
            commit('SET_TOKEN_EXPIRES_IN', null)
            commit('SET_REFRESH_TOKEN_EXPIRES_IN', null)
            commit('SET_TOKEN', null)
            store.dispatch('sessao/changeEmpresa', {})
            store.dispatch('sessao/changeTotem', {})
            store.dispatch('painelcontrole/cleanPainelControleGlobal')
        });
    },

    setRefreshTokenFromLocalStorage({ commit }) {
        const refreshToken = localStorage.getItem('refreshToken')
        if (refreshToken) {
            commit('SET_REFRESH_TOKEN', refreshToken)
        }
    },
    setTokenExpiresInFromLocalStorage({ commit }) {
        const tokenExpiresIn = localStorage.getItem('tokenExpiresIn')
        if (tokenExpiresIn) {
            commit('SET_TOKEN_EXPIRES_IN', tokenExpiresIn)
        }
    },
    setRefreshTokenExpiresInFromLocalStorage({ commit }) {
        const refreshTokenExpiresIn = localStorage.getItem('refreshTokenExpiresIn')
        if (refreshTokenExpiresIn) {
            commit('SET_REFRESH_TOKEN_EXPIRES_IN', refreshTokenExpiresIn)
        }
    },
    updateAuthFromLocalStorage({ dispatch }) {
        dispatch('setRefreshTokenFromLocalStorage')
        dispatch('setTokenExpiresInFromLocalStorage')
        dispatch('setRefreshTokenExpiresInFromLocalStorage')
    },
}